import styled from 'styled-components';

export const StyledBlockedPlayersTable = styled.div `
  .filterBar-searchByKey {
     margin-top: 0;
  }
` as any;
